import request from '@/utils/request'

export function restoreOrder(data) {
  return request({ url: '/orders/restore', method: 'post', data })
}

export function restoreTask(data) {
  return request({ url: '/tasks/restore', method: 'post', data })
}



export function updateOrderProcess(prams) {
  return request({
    url: '/orders/updateorderprocess',
    method: 'get',
    params: prams
  })
}

export function refreshOrderProcess(params) {
  return request({
    url: '/orders/refreshorderprocess',
    method: 'get',
    params
  })
}

export function orderCancel(params) {
  return request({
    url: '/orders/ordercancel',
    method: 'get',
    params: params
  })
}
export function updateOrderDetail(data) {
    return request({
        url: '/orders/updateorderdetail',
        method: 'post',
        data
    })
}

export function endPreOrder(data) {
    return request({
        url: '/orders/enderpreorder',
        method: 'post',
        data
    })
}
export function getPreOrdersList(params) {
    return request({
        url: '/orders/getpreorderlist',
        method: 'get',
        params: params
    })
}

export function newPreOrder(data) {
  return request({
    url: '/orders/newpreorder',
    method: 'post',
    data
  })
}

export function getSellerWechat(params) {
  return request({
    url: '/orders/getsellerwechat',
    method: 'get',
    params: params
  })
}


export function rejectOrder(params) {
  return request({
    url: '/orders/rejectorder',
    method: 'get',
    params: params
  })
}

export function newTask(data) {
  return request({
    url: '/orders/newtask',
    method: 'post',
    data
  })
}

export function upDateTaskDNote(data) {
  return request({
    url: '/orders/updatataskdnote',
    method: 'post',
    data
  })
}

export function upDataOrderScore(data) {
  return request({
    url: '/orders/updataorderscore',
    method: 'post',
    data
  })
}

export function newOrder(data) {
  return request({
    url: '/orders/neworder',
    method: 'post',
    data
  })
}

export function getMyOrders(searchdata) {
  return request({
    url: '/orders/getmyorders',
    method: 'get',
    params: searchdata
  })
}

export function getOrderSalesMembers(orderId) {
  return request({
    url: `/orders/sales-members/${orderId}`,
    method: 'get'
  })
}

export function getOrderSalesMemberCandidates(orderId) {
  return request({
    url: `/orders/sales-member-candidates/${orderId}`,
    method: 'get'
  })
}

export function addOrderSalesMember(orderId, data) {
  return request({
    url: `/orders/sales-members/${orderId}`,
    method: 'post',
    data
  })
}

export function removeOrderSalesMember(orderId, userId) {
  return request({
    url: `/orders/sales-members/${orderId}/${userId}`,
    method: 'delete'
  })
}

export function changeOrderPrimarySales(orderId, data) {
  return request({
    url: `/orders/primary-sales/${orderId}`,
    method: 'patch',
    data
  })
}

export function getshowlist(getshowlistdata) {
  return request({
    url: '/orders/getcompanyorders',
    method: 'get',
    params: { date: getshowlistdata.date,
      searchstr: getshowlistdata.searchstr,
      page: getshowlistdata.page,
      itemslimit: getshowlistdata.itemslimit }
  })
}

export function getSystemOrders(searchdata) {
  return request({
    url: '/system/getsystemorders',
    method: 'get',
    params: searchdata
  })
}

export function getCompanyOrders(searchdata) {
  return request({
    url: '/orders/getcompanyorders',
    method: 'get',
    params: searchdata
  })
}

export function getMyCompanyOrders(data) {
  return request({
    url: '/orders/getmycompanyorders',
    method: 'get',
    params: data
  })
}

export function getClientSeller() {
  return request({
    url: '/orders/getsellerclient',
    method: 'get'
  })
}

export function getPaymentLink(data) {
  return request({
    url: '/payment/getpaymenturl',
    method: 'post',
    data
  })
}

export function newReceived(data) {
  return request({
    url: '/orders/newreceived',
    method: 'post',
    data
  })
}

export function updataOrder(data) {
  return request({
    url: '/orders/updataorder',
    method: 'post',
    data: data
  })
}

export function getWriter(params) {
  return request({
    url: '/orders/getwriter',
    method: 'get',
    params
  })
}

export function getOrderPaymentList(orderid) {
  return request({
    url: '/orders/getorderpaymentlist',
    method: 'get',
    params: { orderid: orderid }
  })
}
export function getOrderRefundsList(orderid) {
  return request({
    url: '/orders/getorderrefundlist',
    method: 'get',
    params: { orderid: orderid }
  })
}
export function updataTaskProcess(data) {
  return request({
    url: '/orders/updatataskprocess',
    method: 'post',
    data: {
      ID: data.ID,
      Process: data.Process
    }
  })
}

export function getCompanyOrderPeople(params) {
  return request({
    url: '/orders/company-order-people',
    method: 'get',
    params
  })
}

export function newRefund(data) {
  return request({
    url: 'orders/newrefund',
    method: 'post',
    data
  })
}
export function upDataOrderNote(data) {
  return request({
    url: 'orders/updataordernote',
    method: 'post',
    data
  })
}

export function searchsubjects(data) {
  return request({
    url: '/orders/searchsubjects',
    method: 'post',
    data
  })
}

export function newsearchsubjects(searchform) {
  return request({
    url: '/orders/newsearchsubjects',
    method: 'get',
    params: searchform
  })
}


export function linkPreorderToOrder(params) {
  return request({
    url: '/orders/linkpreordertoorder',
    method: 'get',
    params
  })
}

